import { createContext, useContext, useEffect, type ReactNode } from 'react';
import { useLocation } from 'react-router-dom';
import { initPostHog, trackPageView } from '@/lib/posthog';

interface PostHogContextValue {
  isInitialized: boolean;
}

const PostHogContext = createContext<PostHogContextValue>({ isInitialized: false });

export const PostHogProvider = ({ children }: { children: ReactNode }) => {
  const location = useLocation();

  useEffect(() => {
    // Initialize PostHog on mount
    initPostHog();
  }, []);

  useEffect(() => {
    // Track page views on route change
    trackPageView();
  }, [location.pathname]);

  return (
    <PostHogContext.Provider value={{ isInitialized: true }}>
      {children}
    </PostHogContext.Provider>
  );
};

export const usePostHog = () => {
  const context = useContext(PostHogContext);
  if (!context) {
    throw new Error('usePostHog must be used within PostHogProvider');
  }
  return context;
};
